import React, {useState} from 'react';
import LogoSvg from '../../svg/Logo.js'
import { connect } from 'react-redux';

import { useNavigate } from 'react-router-dom';


function isValidEmail(mail) {
 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)){
    return (true)
  }
  return (false)
}


function Component(props) {
  const navigate = useNavigate();

  const handleLoginPrimary=async ()=>{
    navigate('/edb1/primary');
  }
  const handleLoginSecondary=async ()=>{
    navigate('/edb1/secondary');
  }



  return (
    <div className='login_root relative flex flex-row justify-end items-center p-[5%]' style={{}}>
      <img src='/background.png' className='absolute w-full h-full top-0 left-0' style={{objectFit:'cover'}}/>
		  <div className='flex flex-col rounded-[12px] border-[#D4D4D4] border-[1px] p-[20px] bg-white max-w-[500px] w-[100%] h-[100%] max-h-[700px] z-[10] justify-center'>
            <div><LogoSvg/></div>
            <div className='login_title'>試用版</div>
            <div className='mt-[43px] text-[16px]'>以試用版身份進入平台</div>           
   

            <div className='login_button gap-[8px] h-[48px] flex flex-row cursor-pointer w-full' onClick={handleLoginPrimary}>登入小學試用版</div>
            <div className='login_button gap-[8px] h-[48px] flex flex-row cursor-pointer w-full' onClick={handleLoginSecondary}>登入中學試用版</div>
        </div>
    </div>
  );
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)
  